<template>
  <div>
    <div class="ordersubmit-container">
      <!-- 错误引导(此元素位置不可放在详情图后)-->
      <div class="walk-through" v-if="walkThroughShow">
        <!-- <div class="through-showbox through-anim"></div> -->
        <!-- <div class="through-showbox through-anim" :style="guideShopNameStyle"></div> -->
        <div class="through-showbox through-anim" :style="guideGoodsNameStyle"></div>
        <div class="overlay-hole-img"></div>
        <div class="tool-tip">
          <img class="tooltip_err" :src="errTipImg" alt="" />
          <div class="tooltip_btn" @click="walkThroughShow = false">
            <img :src="knowBtnImg" alt="" />
          </div>
        </div>
      </div>
      <!-- 错误引导 end -->
      <div class="b_black order-time flex space-between">
        <div class="flex align-items">
          <span class="iconfont icon-time"></span>
          <span v-if="isSystemOutTime" class="title-tip">订单已超时，请尽快上传订单截图提交</span>
          <span v-else class="title-tip">{{ !manualOrderAgain ? (isCounting ? '等待付款' : '订单已超时') : '等待重新提交' }}</span>
        </div>
        <!-- 剩余时间 -->
        <div class="icon-time-block" v-if="!isSystemOutTime && !manualOrderAgain">
          <template v-if="isCounting && dataInfo.RemainderPayTime">
            <span class="fs-26"
              >剩余：{{ dataInfo.RemainderPayTime.Hours || 0 }} 小时
              {{ dataInfo.RemainderPayTime.Minutes > 0 ? dataInfo.RemainderPayTime.Minutes : dataInfo.RemainderPayTime.Seconds > 0 ? 1 : 0 }}
              分钟</span
            >
          </template>
        </div>
      </div>
      <div class="order-list b_fff">
        <div class="item-title flex">
          <div class="order-title-left" :class="{ promoteZIndex: walkThroughShow }">
            <plat-formLogo :shopType="String(dataInfo.ShopType).toUpperCase()"></plat-formLogo>
            <span class="txt">{{ dataInfo.ShopName || '----' }}</span>
          </div>
        </div>
        <div class="item-list flex">
          <div class="item-image">
            <img :class="{ 'goods-img-level': walkThroughShow }" :src="dataInfo.WAPPicUrl" alt="" />
          </div>
          <div class="item-txt">
            <div class="item-txt-top">
              <div class="item-txt-top-1">
                <span>{{ dataInfo.TitleShort || '----' }}</span>
              </div>
            </div>
            <div class="item-txt-btm">
              <div class="flex space-between goods-price">
                <span class="price">￥{{ dataInfo.ProductPrice | toFixed }}</span>
                <span>x1</span>
              </div>
              <div class="goods-tag"><span class="tag">限购1件</span><span class="tag" @click="riskDialogShow = true">垫付零风险</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="order_from">
        <div class="b_fff mar_t_20">
          <!-- 淘宝详情页领券 -->
          <div class="d-list-text flex space-between" v-if="dataInfo.IsCoupon">
            <div class="flex align-items">
              <div class="d-list-left">
                <span>{{ platformTypeText }}详情页领券</span>
              </div>
              <span class="question" @click.stop="checkInstructions('coupons')">?</span>
            </div>
            <div>
              <span class="coupon-tag-sure">{{ dataInfo.CouponAmount }}元券</span>
            </div>
          </div>
          <!-- 付款说明 -->
          <div class="d-list-text flex space-between">
            <div class="flex align-items">
              <div class="d-list-left">先付款</div>
              <div class="tip" v-if="dataInfo.FreightType">{{ '(含运费￥' + dataInfo.Freight.toFixed(2) + ')' }}</div>
            </div>
            <div class="flex align-items">
              <div class="priceDiff" @click="showDiff({ taskID: taskID, dataInfo, platform: platformType })">
                差价反馈
              </div>
              ￥ {{ dataInfo.ProductPrice | toFixed }}
            </div>
          </div>
          <!-- 收货后返利 -->
          <div class="d-list-text flex space-between">
            <div class="flex align-items">
              <div class="d-list-left">收货后返利</div>
            </div>
            <div class="flex middle" v-if="dataInfo.FreeCardNum">￥ {{ dataInfo.ProductPrice.toFixed(2) }}</div>
            <div class="flex middle" v-else>￥ {{ Number(dataInfo.RebateAmount || 0).toFixed(2) }}</div>
          </div>
          <!-- 返利方式 -->
          <div class="d-list-text flex space-between">
            <div class="flex align-items">
              <div class="d-list-left">
                <span>返利方式</span>
              </div>
              <span class="question" @click.stop="checkInstructions('rebate')">?</span>
            </div>
            <div>微信提现</div>
          </div>
        </div>
        <!-- 免单卡 -->
        <div class="d-list-text flex space-between mar_t_20 b_fff" v-if="dataInfo.FreeCardNum">
          <div class="flex align-items">
            <div class="d-list-left">免单卡</div>
          </div>
          <div class="flex middle">{{ dataInfo.FreeCardNum }}张</div>
        </div>
        <!-- 订单编号 -->
        <div class="b_fff mar_t_20 guide-order">
          <div class="d-list-text flex space-between">
            <div class="flex middle title-width">
              <div class="d-list-left">
                <span>订单编号</span>
              </div>
            </div>
            <div class="tr flex list-text-form">
              <input :type="platformType ? 'text' : 'tel'" v-model="orderNumber" @keyup="limtInput" @blur="orderNumberBlur" maxlength="30" placeholder="请输入订单编号进行提交" />
            </div>
          </div>
        </div>
        <template v-if="manualOrder">
          <div class="b_black err-b fs-26">
            <span>{{ errMsgText }}，请在{{ platformTypeText }}APP截取订单截图进行上传</span>
            <span class="iconfont icon-sanjiaoxing"></span>
          </div>
          <div class="order-id b_fff flex">
            <span class="t_999 fs-26">订单编号：{{ orderNumber }}</span>
            <button class="or-tag" size="mini" plain="true" @click="inputErr">
              我填错了
            </button>
          </div>
          <!-- upload -->
          <div class="weui-cells sub-upload">
            <div class="weui-cell">
              <div class="weui-uploader">
                <div class="weui-uploader__bd">
                  <div class="weui-uploader__files">
                    <div class="weui-uploader__input-box">
                      <div class="weui-uploader__input">
                        <input type="file" class="upload-input" accept="image/*" @change="selectImgChange($event)" />
                      </div>
                    </div>
                    <div
                      v-if="isUploading || isUploadFail || uploadImgSrc"
                      class="weui-uploader__file upload-img"
                      :class="[isUploading || isUploadFail ? 'weui-uploader__file_status' : '']"
                      @click="previewImage('upload')"
                    >
                      <img class="weui-uploader__img" v-if="uploadImgSrc" :src="uploadImgSrc" />
                      <div class="weui-uploader__file-content" v-if="isUploading">{{ uploadingProgress }}%</div>
                      <div class="weui-uploader__file-content" v-if="isUploadFail">
                        <i>上传失败</i>
                      </div>
                    </div>
                    <!-- 示例图 -->
                    <div class="weui-uploader__file weui-uploader__file_status" @click="previewImage('exam')">
                      <img class="weui-uploader__img" :src="showRootPath + samplePic" />
                      <div class="weui-uploader__file-content">示例</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- 按钮 -->
    <div class="order-btn b_fff flex" :class="{ 'walk-through-hidden': walkThroughShow }">
      <div class="platform-know" @click="platformShow"><i class="icon-changguizidian iconfont"></i>平台须知</div>
      <div>
        <mt-button class="shCancelBtn" type="default" :disabled="isLoading" @click="cancelOrder">取消订单</mt-button>
      </div>
      <div class="btn-margin">
        <mt-button class="shPrimaryBtn" type="danger" @click="formSubmit" :disabled="isLoading">立即提交</mt-button>
      </div>
    </div>
    <preview-dialog v-if="previewDialogShow" @close="previewDialogShow = false" :img-src="previewImgSrc"> </preview-dialog>
    <!-- 平台须知 -->
    <platform-dialog :visible="platformDialogShow" :comfirm-text="platformText" :is-disable="platformDisable" :bottom-tip-show="platformTipShow" @confirm="confirm" @close="platformDialogShow = false">
    </platform-dialog>
    <!-- 垫付保障弹窗 -->
    <risk-dialog v-if="riskDialogShow" :platform-type="platformType" @close="riskDialogShow = false"> </risk-dialog>
    <!-- 取消订单弹窗 -->
    <cancel-order-popup
      :isShow="isShowCancelOrderPopup"
      :isShowChangeKeyWordBtn="isShowChangeKeyWordBtn"
      :isWaitingSearch="false"
      @changeKeyWord="customChangeKeyWordEvent"
      @confirm="customCancelSaleTaskAccept"
      @close="closeCancelOrderPopup"
    ></cancel-order-popup>
  </div>
</template>

<script>
import axios from 'axios'
import { IMG_BASE_URL } from '@/config'
import { Toast, Indicator, MessageBox } from 'mint-ui'
import PreviewDialog from '@/components/puppetComponent/PreviewDialog'
import RiskDialog from '@/components/puppetComponent/RiskDialog'
import PlatformDialog from './children/PlatformDialog'
import cancelOrder from '@/mixins/cancelOrder'
import {
  SubmitOrder,
  RemainderPayTimeGet,
  UpaiyunUploadInfoGet,
  CheckPlatformOrderID,
  CheckPlatformOrderIdPdd,
  CheckPlatformOrderIDJd,
  CheckPlatformOrderIDDouDian,
  CheckPlatformOrderIDTgc,
  SaleOrderCommit,
  ManualCommitOrder,
  ManualCommitOrderAgain,
  AgreeProtocol
} from '@/api/order'
import Utils from '@/utils/base'
import feedbackBtnEvent from '@/mixins/feedbackBtnEvent'

export default {
  mixins: [feedbackBtnEvent, cancelOrder],
  data() {
    return {
      dataInfo: {},
      orderNumber: '',
      platformType: 0, // 平台类型 0：淘宝 1：拼多多
      platformTypeText: '淘宝',
      isLoading: false,
      manualOrder: false,
      manualOrderAgain: false,
      isUploading: false,
      isUploadFail: false,
      uploadingProgress: 0,
      uploadImgSrc: '',
      uploadUserInfo: {},
      taskID: null,
      showRootPath: IMG_BASE_URL,
      samplePic: '/upaiyun/Sys/20180502/5032722541007913199.jpg',
      errMsgText: '网络出错啦',
      isCounting: true,
      countTimeOut: '',
      buyerNickName: '',
      buyerTel: '',
      payTime: '',
      previewImgSrc: '',
      previewDialogShow: false,
      // 保障弹窗
      riskDialogShow: false,
      // 协议弹窗相关
      platformDialogShow: false,
      platformText: '我知道了',
      platfromInterval: null,
      platformDisable: false,
      platformTipShow: true,
      platfromTime: 5,
      // 是否展现了平台须知
      isAgreenProtocol: false,
      isFreeCard: false, // 是否是免单订单
      isSystemOutTime: false, // 是否为服务器的超时订单
      payPriceLessErr: null, // 验证提交订单时价格过低错误
      payPriceOverErr: null, // 验证提交订单时价格过高错误
      fromRouterName: null,
      // 错误引导显示
      errTipImg: IMG_BASE_URL + '/upaiyun/Sys/20210122/4646329239889142380.png',
      walkThroughShow: false,
      knowBtnImg: IMG_BASE_URL + '/upaiyun/Sys/20190829/5157027486024063296.png',
      guideShopNameStyle: null
    }
  },
  components: {
    PreviewDialog,
    PlatformDialog,
    RiskDialog
  },
  created() {
    if (this.$route.query.isFreeCard || this.$route.query.isFreeCard === true) {
      this.isFreeCard = true
    }
    this.taskID = this.$route.query.taskID ? this.$route.query.taskID : null
    if (this.$route.query.submitAgain === 'again') {
      this.manualOrderAgain = true
    } else {
      this.manualOrderAgain = false
    }
  },
  mounted() {
    if (this.taskID) {
      this.fetchData()
      this.fetchUploadInfo()
    } else {
      Toast('无任务ID')
      this.$router.go(-1)
    }
    window.addEventListener('resize', this.inputFocusResize)
  },
  beforeDestroy() {
    if (this.countTimeOut) {
      clearTimeout(this.countTimeOut)
      this.countTimeOut = null
    }
    clearInterval(this.platfromInterval)
    window.removeEventListener('resize', this.inputFocusResize)
  },
  computed: {
    rebatePrice() {
      if (this.dataInfo.RebateAmount > this.dataInfo.ProductPrice) {
        return Number(this.dataInfo.ProductPrice).toFixed(2)
      } else {
        return Number(this.dataInfo.RebateAmount).toFixed(2)
      }
    }
  },
  methods: {
    fetchData() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      let params = { taskID: this.taskID }
      SubmitOrder(params)
        .then((res) => {
          Indicator.close()
          let resData = res.AcceptTaskSetp3Info
          this.isAgreenProtocol = res.IsAgreeProtocol
          this.isSystemOutTime = res.IsSystemOutTime
          if (!this.manualOrderAgain) {
            if (resData.RemainderPayTime.Hours <= 0 && resData.RemainderPayTime.Minutes <= 0) {
              // 停止循环 改变页面展现
              this.stopCounting()
              if (this.countTimeOut) clearTimeout(this.countTimeOut)
            } else {
              // 开始循环/继续循环
              this.isCounting = true
              if (this.countTimeOut) clearTimeout(this.countTimeOut)
              this.countTimeOut = setTimeout(this.fetchTimeRemain, (resData.RemainderPayTime.Seconds + 1) * 1000)
            }
          }
          // 展示协议弹窗
          if (!this.isAgreenProtocol) {
            this.platfromTime = 5
            this.platformText = '同意（5s）'
            this.platformDialogShow = true
            this.platfromInterval = setInterval(this.countDown, 1000)
            this.platformDisable = true
            this.platformTipShow = true
          }
          if (this.SHOP_TYPE_2['淘工厂'] === resData.ShopType) {
            resData.ShopName = '天天特卖工厂店'
          }
          this.dataInfo = resData
          // 新增逻辑 -- start
          this.dataInfo = {
            ...this.dataInfo,
            TaskId: this.taskID
          }
          this.handelCancelOrder(this.dataInfo)
          // 新增逻辑 -- end
          switch (String(this.dataInfo.ShopType).toUpperCase()) {
            case 'J':
              this.platformType = this.PLATFORM_TYPE['京东']
              this.platformTypeText = '京东'
              this.samplePic = '/upaiyun/Sys/20211116/4943249414435902338.jpg'
              break
            case 'P':
              this.platformType = this.PLATFORM_TYPE['拼多多']
              this.platformTypeText = '拼多多'
              this.samplePic = '/upaiyun/Sys/20200108/5590241887157279715.jpg'
              break
            case 'D':
              this.platformType = this.PLATFORM_TYPE['抖店']
              this.platformTypeText = '抖音'
              this.samplePic = '/upaiyun/Sys/20220104/4955643033625007387.jpg'
              break
            case 'T':
              this.platformType = this.PLATFORM_TYPE['淘工厂']
              this.platformTypeText = '淘宝'
              this.samplePic = '/upaiyun/Sys/20180502/5032722541007913199.jpg'
              break
            default:
              this.platformType = this.PLATFORM_TYPE['淘宝']
              this.platformTypeText = '淘宝'
              this.samplePic = '/upaiyun/Sys/20180502/5032722541007913199.jpg'
              break
          }
        })
        .catch((err) => {
          Indicator.close()
          Toast(err.ErrMsg)
        })
    },
    inputFocusResize() {
      // 解决问题：微信内置浏览器浏览的H5页面弹出键盘时遮盖文本框
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        window.setTimeout(() => {
          document.activeElement.scrollIntoViewIfNeeded()
        }, 0)
      }
    },
    // 停止倒计时：
    stopCounting() {
      this.isCounting = false
    },
    // 获取剩余时间单独接口
    fetchTimeRemain() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      let params = { taskID: this.taskID }
      RemainderPayTimeGet(params)
        .then((res) => {
          Indicator.close()
          if (!res.IsError) {
            let resData = res.RemainderPayTime
            if (resData.Hours <= 0 && resData.Minutes <= 0) {
              // 停止循环 改变页面展现
              this.stopCounting()
              if (this.countTimeOut) clearTimeout(this.countTimeOut)
            } else {
              // 开始循环/继续循环
              this.isCounting = true
              if (this.countTimeOut) clearTimeout(this.countTimeOut)
              this.countTimeOut = setTimeout(this.fetchTimeRemain, (resData.Seconds + 1) * 1000)
            }
            this.$set(this.dataInfo, 'RemainderPayTime', resData)
          } else {
            if (res.ErrCode === 301) {
              Toast('会话超时，请关闭小程序，重新进入')
            } else if (res.ErrCode === 302) {
              Toast('账号被冻结，可联系客服处理')
            } else {
              if (res.ErrMsg) {
                Toast(res.ErrMsg)
              }
            }
          }
        })
        .catch(() => {
          Toast('服务器开了个小差，请稍后重新进入')
          Indicator.close()
        })
    },
    // 获取上传图片信息
    fetchUploadInfo() {
      UpaiyunUploadInfoGet().then((res) => {
        this.uploadUserInfo.uploadUrl = res.UploadUrl
        this.uploadUserInfo.loginName = res.LoginName
        this.uploadUserInfo.password = res.Screct
      })
    },
    // 图片上传
    selectImgChange(event) {
      let _this = this
      let rootPath = this.showRootPath
      let file = event.target.files[0]
      if (file) {
        let data = new FormData()
        data.append('souhuoUpload', file)
        document.querySelector('.upload-input').value = ''
        axios({
          method: 'post',
          url: this.uploadUserInfo.uploadUrl,
          params: {
            loginName: this.uploadUserInfo.loginName,
            secret: this.uploadUserInfo.password
          },
          data: data,
          timeout: 60000,
          onUploadProgress: function(progressEvent) {
            // 显示相应的上传进度
            let percent = (progressEvent.loaded / progressEvent.total) * 100
            _this.uploadingProgress = parseInt(percent)
            _this.isUploading = true
            _this.isUploadFail = false
          }
        })
          .then((res) => {
            if (res.status === 200 && res.data.StatusCode === 200) {
              // 上传成功，展示图片，隐藏进度条
              this.uploadImgSrc = rootPath + res.data.Message
              this.isUploading = false
              this.isUploadFail = false
            } else {
              Toast(res.Message)
              this.uploadingProgress = 0
              this.uploadImgSrc = ''
              this.isUploading = false
              this.isUploadFail = true
            }
          })
          .catch(() => {
            Toast('上传图片失败！请重新上传')
            this.uploadingProgress = 0
            this.uploadImgSrc = ''
            this.isUploading = false
            this.isUploadFail = true
          })
      }
    },
    // 说明提示
    checkInstructions(val) {
      let tigInfo = ''
      if (val === 'rebate') {
        tigInfo = `收到商品后，请前往${this.platformTypeText}APP确认收货，平台确认后将自动返利至余额，前往余额提现即可微信提现`
      } else {
        tigInfo = `请在${this.platformTypeText}找到该商品对应的优惠券领取，确认先付款金额正确；如未找到或付款金额不一致，可点击差价反馈进行反馈`
      }
      MessageBox({
        title: '提示',
        message: tigInfo,
        showCancelButton: false,
        confirmButtonText: '我知道了',
        confirmButtonClass: 't_f23030'
      })
    },
    // 我填错了
    inputErr() {
      this.manualOrder = false
    },
    limtInput() {
      // 拼多多订单号可以输入‘-’字符，由于ios九宫格输入‘-’字符时会替代前一个输入的字符，所以在keyup事件不做输入限制,抖音可以是字母
      if (this.platformType) return
      let numRegExp = new RegExp('\\D', 'ig')
      this.orderNumber = this.orderNumber.replace(numRegExp, '')
    },
    orderNumberBlur() {
      let numRegExp = ''
      switch (this.platformType) {
        case this.PLATFORM_TYPE['拼多多']:
          numRegExp = new RegExp('[^0-9-]', 'ig')
          break
        case this.PLATFORM_TYPE['抖店']:
          numRegExp = new RegExp('[^0-9a-zA-Z]', 'ig')
          break
        default:
          // 淘宝、天猫、淘工厂
          numRegExp = new RegExp('\\D', 'ig')
          break
      }
      this.orderNumber = this.orderNumber.replace(numRegExp, '')
      setTimeout(function() {
        window.scrollTo(0, 0)
      }, 100)
    },
    previewImage(type) {
      if (type === 'upload') {
        this.previewImgSrc = this.uploadImgSrc
      } else if (type === 'exam') {
        this.previewImgSrc = this.showRootPath + this.samplePic
      }
      this.previewDialogShow = true
    },
    // 验证订单编号
    validateOrder() {
      let orderNumber = this.orderNumber
      if (!orderNumber) {
        Toast('请输入订单编号')
        return false
      }
      switch (this.platformType) {
        case this.PLATFORM_TYPE['京东']:
          if (orderNumber.length < 10 || orderNumber.length > 20) {
            Toast('京东订单编号长度为 10 ~ 20 位数')
            return false
          }
          break
        case this.PLATFORM_TYPE['拼多多']:
          if (orderNumber.length < 20 || orderNumber.length > 24) {
            Toast('拼多多订单编号长度为 20 ~ 24 位数')
            return false
          }
          break
        case this.PLATFORM_TYPE['抖店']:
          if (orderNumber.length < 18 || orderNumber.length > 30) {
            Toast('抖音订单编号长度为 18 ~ 30 位数')
            return false
          }
          break
        default:
          // 淘宝、天猫、淘工厂
          if (orderNumber.length < 18 || orderNumber.length > 25) {
            Toast('订单编号长度为 18 ~ 25 位数')
            return false
          }
          break
      }
      return true
    },
    // 验证订单
    checkPlatformOrderIDApi(cb) {
      let postData = {
        TaskID: this.taskID,
        PlatformOrderID: this.orderNumber,
        FCoupon: '',
        payPriceLessConfirm: this.payPriceLessErr,
        payPriceOverConfirm: this.payPriceOverErr
      }
      let res = null
      this.isLoading = true
      switch (this.platformType) {
        case this.PLATFORM_TYPE['京东']:
          res = CheckPlatformOrderIDJd(postData)
          break
        case this.PLATFORM_TYPE['拼多多']:
          res = CheckPlatformOrderIdPdd(postData)
          break
        case this.PLATFORM_TYPE['抖店']:
          res = CheckPlatformOrderIDDouDian(postData)
          break
        case this.PLATFORM_TYPE['淘工厂']:
          res = CheckPlatformOrderIDTgc(postData)
          break
        default:
          // 0 淘宝/天猫
          res = CheckPlatformOrderID(postData)
          break
      }
      res
        .then(() => {
          this.isLoading = false
          if (cb) cb(res)
        })
        .catch((err) => {
          Indicator.close()
          this.isLoading = false
          this.handleOrderAndSubmitErr(err)
        })
    },
    // 超时时在检测一次订单在服务器是否超时
    outTimeSubmitCheckAgain() {
      SubmitOrder({ taskID: this.taskID })
        .then((res) => {
          // isSystemOutTime为true时，说明用户已在淘宝/拼多多购买，则正常提交订单到服务器，前端不做限制
          this.isSystemOutTime = res.IsSystemOutTime
          if (this.isSystemOutTime) this.submitToService()
          else {
            Toast('订单已超时，请重新选择商品')
            setTimeout(() => {
              this.$router.replace('souhuo')
            }, 1500)
          }
        })
        .catch((err) => {
          Indicator.close()
          Toast(err.ErrMsg)
        })
    },
    // 第一次自动提交订单
    autoFirstSubmitOrder(postData) {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      // 检测订单
      this.checkPlatformOrderIDApi((checkRes) => {
        // 自动提交订单
        this.isLoading = true
        SaleOrderCommit(postData)
          .then((res) => {
            Indicator.close()
            this.isLoading = false
            // 后端是否修改【是否新人】。如果有修改，返回Data {isNewPerson}，否则还是返回Msg
            // 之所以不直接清空新人状态，是因为订单有可能已经自动取消，此时新人用户状态还是没改变。
            if (res.Data && res.Data.isNewPerson != null) {
              Utils.setNewcomerStorage(res.Data.isNewPerson)
            }
            if (res.AdditionalRemind) {
              MessageBox({
                title: '提示',
                message: res.AdditionalRemind,
                showCancelButton: false,
                confirmButtonText: '我知道了',
                confirmButtonClass: 't_f23030'
              }).then((action) => {
                if (action === 'confirm') {
                  // 参照原有的流程跳转对应提交成功页面
                  this.$router.push({
                    name: 'orderSuccess',
                    query: {
                      ismanual: false,
                      productID: this.dataInfo.ProductID,
                      titleShort: this.dataInfo.TitleShort,
                      taskID: this.taskID
                    }
                  })
                }
              })
              return
            }
            Toast('提交成功')
            setTimeout(() => {
              this.$router.push({
                name: 'orderSuccess',
                query: {
                  ismanual: false,
                  productID: this.dataInfo.ProductID,
                  titleShort: this.dataInfo.TitleShort,
                  taskID: this.taskID
                }
              })
            }, 300)
          })
          .catch((err) => {
            Indicator.close()
            this.isLoading = false
            this.handleOrderAndSubmitErr(err)
          })
      })
    },
    // 立即提交
    formSubmit() {
      if (this.isLoading) return
      if (!this.isCounting) this.outTimeSubmitCheckAgain()
      else this.submitToService()
    },
    // 提交订单到服务器
    submitToService() {
      // removeStore('SHNEWHANDGUIDE')
      let { manualOrder, manualOrderAgain, taskID, orderNumber } = this
      if (!this.validateOrder()) return
      let postData = {
        TaskID: taskID,
        PlatformOrderID: orderNumber,
        PlatformType: this.platformType, // 0：淘宝，2：拼多多
        FormId: '',
        FCoupon: ''
      }
      // 手动提交模块是否展现
      if (manualOrder) {
        if (this.isUploadFail) {
          Toast('上传图片失败，请重新上传后再提交')
          return
        }
        if (this.isUploading) {
          Toast('正在上传图片，请稍后再提交')
          return
        }
        if (!this.uploadImgSrc) {
          Toast('请先上传订单截图')
          return
        } else {
          postData.AuditImg = this.uploadImgSrc
          postData.ErrMsg = this.errMsgText
          postData.BuyerNick = this.buyerNickName
          postData.Tel = this.buyerTel
          postData.PayTime = this.payTime
        }
        if (manualOrderAgain) {
          // 第二次手动提交接口
          Indicator.open({
            text: '加载中',
            spinnerType: 'triple-bounce'
          })
          this.isLoading = true
          ManualCommitOrderAgain(postData)
            .then((res) => {
              Indicator.close()
              this.isLoading = false
              if (res.Data && res.Data.isNewPerson != null) {
                Utils.setNewcomerStorage(res.Data.isNewPerson)
              }
              if (res.AdditionalRemind) {
                MessageBox({
                  title: '提示',
                  message: res.AdditionalRemind,
                  showCancelButton: false,
                  confirmButtonText: '我知道了',
                  confirmButtonClass: 't_f23030'
                }).then((action) => {
                  if (action === 'confirm') {
                    // 参照原有的流程跳转对应提交成功页面
                    this.$router.push({
                      name: 'orderSuccess',
                      query: {
                        ismanual: true,
                        productID: this.dataInfo.ProductID,
                        titleShort: this.dataInfo.TitleShort
                      }
                    })
                  }
                })
                return
              }
              Toast('提交成功')
              setTimeout(() => {
                this.$router.push({
                  name: 'orderSuccess',
                  query: {
                    ismanual: true,
                    productID: this.dataInfo.ProductID,
                    titleShort: this.dataInfo.TitleShort
                  }
                })
              }, 300)
            })
            .catch((res) => {
              Indicator.close()
              this.isLoading = false
              if (res.ErrMsg) {
                Toast(res.ErrMsg)
              }
            })
        } else {
          this.ManualCommitOrder(postData)
        }
      } else {
        this.autoFirstSubmitOrder(postData)
      }
    },
    // 第一次手动提交
    ManualCommitOrder(postData) {
      // 第一次手动提交接口
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.isLoading = true
      ManualCommitOrder(postData)
        .then((res) => {
          Indicator.close()
          this.isLoading = false
          if (res.Data && res.Data.isNewPerson != null) {
            Utils.setNewcomerStorage(res.Data.isNewPerson)
          }
          if (res.AdditionalRemind) {
            MessageBox({
              title: '提示',
              message: res.AdditionalRemind,
              showCancelButton: false,
              confirmButtonText: '我知道了',
              confirmButtonClass: 't_f23030'
            }).then((action) => {
              if (action === 'confirm') {
                // 参照原有的流程跳转对应提交成功页面
                this.$router.push({
                  name: 'orderSuccess',
                  query: {
                    ismanual: true,
                    productID: this.dataInfo.ProductID,
                    titleShort: this.dataInfo.TitleShort
                  }
                })
              }
            })
            return
          }
          Toast('提交成功')
          setTimeout(() => {
            this.$router.push({
              name: 'orderSuccess',
              query: {
                ismanual: true,
                productID: this.dataInfo.ProductID,
                titleShort: this.dataInfo.TitleShort
              }
            })
          }, 300)
        })
        .catch((res) => {
          Indicator.close()
          this.isLoading = false
          if (res.ErrMsg) {
            Toast(res.ErrMsg)
          }
        })
    },
    // 处理订单验证和自动提交订单的错误
    handleOrderAndSubmitErr(err) {
      let autoSubmitPostData = {
        TaskID: this.taskID,
        PlatformOrderID: this.orderNumber,
        PlatformType: this.platformType,
        FormId: '',
        FCoupon: ''
      }
      this.payPriceLessErr = false
      this.payPriceOverErr = false
      let msgBoxShowText = err.ErrMsg
      // 京东订单状态【暂停】类型 - 自动录入特卖订单提交记录表（新）
      if (this.platformType === this.PLATFORM_TYPE['京东'] && err.JdStatusPause === 1) {
        let postData = {
          TaskID: this.taskID,
          PlatformOrderID: this.orderNumber,
          PlatformType: this.platformType, // 0：淘宝，2：拼多多
          FormId: '',
          FCoupon: '',
          BuyerNick: err.BuyerNick,
          Tel: err.Tel,
          PayTime: err.PayTime,
          ErrMsg: err.ErrMsg,
          JdStatusPause: err.JdStatusPause
        }
        this.ManualCommitOrder(postData)
        return
      }
      // 淘工厂订单状态【暂停】类型 - 自动录入特卖订单提交记录表（新）
      if (this.platformType === this.PLATFORM_TYPE['淘工厂'] && err.TgcNotExistsAuditNoPass === 1) {
        let postData = {
          TaskID: this.taskID,
          PlatformOrderID: this.orderNumber,
          PlatformType: this.platformType, // 0：淘宝，2：拼多多
          FormId: '',
          FCoupon: '',
          BuyerNick: err.BuyerNick,
          Tel: err.Tel,
          PayTime: err.PayTime,
          ErrMsg: err.ErrMsg,
          TgcNotExistsAuditNoPass: err.TgcNotExistsAuditNoPass
        }
        this.ManualCommitOrder(postData)
        return
      }
      if (err.IsOnlyPayPriceLess) {
        // 返回的异常是：'返利金额异常，请手动提交订单', '订单金额低于平台成交价，请手动提交订单'。（表示支付金额过低）
        MessageBox({
          title: '提示',
          message: `订单实际支付金额低于平台商品价格(${err.ProductPrice}元)，
            返利金额将自动同步为：<span class="t_f23030">${err.RebatePriceNew}</span>元，是否确认提交？`,
          showCancelButton: true,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          confirmButtonText: '确认',
          confirmButtonClass: 't_f23030'
        }).then((action) => {
          // 不进入手动提交，用户确认后直接提交
          if (action === 'confirm') {
            this.payPriceLessErr = true
            this.autoFirstSubmitOrder(autoSubmitPostData)
          }
        })
        return
      } else if (err.IsOnlyPayPriceOver) {
        // 返回的异常是：支付金额高于商品成交价。（表示支付金额过高）
        MessageBox({
          title: '提示',
          message: `订单实际支付金额高于平台商品价格(${err.ProductPrice}元)，
            平台返利金额不变仍为：<span class="t_f23030">${err.BuyRebatePrice}</span>元，是否确认继续提交？`,
          showCancelButton: true,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          confirmButtonText: '确认',
          confirmButtonClass: 't_f23030'
        }).then((action) => {
          if (action === 'confirm') {
            this.payPriceOverErr = true
            this.autoFirstSubmitOrder(autoSubmitPostData)
          }
        })
        return
      } else if (err.ErrMsg === '该笔订单为淘客订单，已被取消接手，限制24小时购买相同商品；请前往淘宝进行退款，避免造成损失；购物时确保仅使用淘宝APP搜索购买，避免被再次限制') {
        MessageBox({
          title: '提示',
          message: `该笔订单为淘客订单，已被取消接手，请前往淘宝进行退款，避免造成损失。<br>有关淘客的具体规则，可点击左侧查看规则进行查看。`,
          showCancelButton: true,
          confirmButtonText: '我知道了',
          cancelButtonClass: 't_blue',
          confirmButtonClass: 'c000',
          cancelButtonText: '查看规则'
        }).then((action) => {
          if (action === 'confirm') {
            this.$router.push({
              name: 'souhuo'
            })
          } else {
            this.$router.push({
              name: 'violationDetail',
              query: {
                type: 0
              }
            })
          }
        })
      } else if (err.ErrMsg === '购买错商品了，请退款后重新下单') {
        MessageBox({
          title: '提示',
          message: msgBoxShowText,
          showCancelButton: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          confirmButtonText: '我知道了',
          confirmButtonClass: 't_f23030'
        }).then((action) => {
          if (action === 'confirm') {
            this.setGoodsNameStyle('.item-txt-top')
            this.walkThroughShow = true
          }
        })
      } else if (err.ErrMsg === '接口异常，请手动提交订单') {
        MessageBox({
          title: '提示',
          message: `提交失败，请重新核对店铺名称【${err.ShopName}】和 订单编号。如确认无误，请手动提交后等待审核`,
          showCancelButton: false,
          confirmButtonText: '我知道了',
          confirmButtonClass: 't_f23030'
        })
      } else if (err.ErrMsg === '该笔订单使用了拼多多平台优惠，无法提交成功') {
        MessageBox({
          title: '提示',
          message: '由于订单使用了拼多多平台优惠，无法提交成功；平台不支持使用拼多多平台优惠，请退款重新购买后，再次尝试提交',
          showCancelButton: false,
          confirmButtonText: '我知道了',
          confirmButtonClass: 't_f23030'
        })
        return
      } else if (/商品已开启优质买号识别，当前买号/.test(err.ErrMsg) && /非优质买号，订单已被取消接手，请前往淘宝退款，避免造成损失/.test(err.ErrMsg)) {
        MessageBox({
          title: '提示',
          message: err.ErrMsg,
          showCancelButton: false,
          confirmButtonText: '我知道了',
          confirmButtonClass: 't_f23030'
        }).then(() => {
          this.$router.push({
            name: 'souhuo'
          })
        })
      } else if (/商品已开启优质买家/.test(err.ErrMsg) && /才允许购买，后续请继续购买其他商品并保持良好的购物行为，即可有机会升级至优质买家/.test(err.ErrMsg)) {
        MessageBox({
          title: '提示',
          message: err.ErrMsg,
          showCancelButton: false,
          confirmButtonText: '我知道了',
          confirmButtonClass: 't_f23030'
        }).then(() => {
          this.$router.push({
            name: 'souhuo'
          })
        })
      }  else if (/暂不符合该商品的购买要求，换件商品看看吧~/.test(err.ErrMsg)) {
        MessageBox({
          title: '提示',
          message: err.ErrMsg,
          showCancelButton: false,
          confirmButtonText: '我知道了',
          confirmButtonClass: 't_f23030'
        }).then(() => {
          this.$router.push({
            name: 'souhuo'
          })
        })
      } else {
        MessageBox({
          title: '提示',
          message: msgBoxShowText,
          showCancelButton: false,
          confirmButtonText: '我知道了',
          confirmButtonClass: 't_f23030'
        })
      }
      // 提交错误转为手动提交
      if (err.IsManual) {
        let nickName = ''
        let tel = ''
        let time = ''
        if (err.BuyerNick !== undefined) {
          nickName = err.BuyerNick
          tel = err.Tel
          time = err.PayTime
        }
        this.errMsgText = err.ErrMsg
        this.manualOrder = true
        this.buyerNickName = nickName
        this.buyerTel = tel
        this.payTime = time
      }
    },
    countDown() {
      let { platfromTime } = this
      this.platformText = `同意（${platfromTime}s）`
      this.platfromTime = platfromTime - 1
      if (platfromTime <= 0) {
        clearInterval(this.platfromInterval)
        this.platformText = '同意'
        this.platfromInterval = null
        this.platformDisable = false
      }
    },
    // 平台须知
    platformShow() {
      clearInterval(this.platfromInterval)
      this.platfromTime = 5
      this.platformText = '我知道了'
      this.platformDialogShow = true
      this.platformDisable = false
      this.platformTipShow = false
    },
    // 关闭平台须知弹窗
    confirm() {
      if (!this.platformDisable) {
        // 点击【平添须知】显示弹窗后，再关闭，不发送请求
        if (this.platformText !== '我知道了') {
          AgreeProtocol(null)
        }
        this.platformDialogShow = false
      }
    },
    // 设置引导的商品名高亮框的样式
    setGoodsNameStyle(className, type) {
      this.$nextTick(() => {
        let elem = document.querySelector(className)
        let elemH = elem.clientHeight
        if (type === 'order') {
        } else {
          this.guideGoodsNameStyle = {
            width: elem.clientWidth + 'px',
            height: elemH + 'px',
            top: elem.parentNode.offsetTop + 'px',
            left: elem.parentNode.offsetLeft - 5 + 'px',
            borderRadius: '5px'
          }
        }
      })
    },
    // 自定义取消订单按钮成功和失败失败后的操作
    customCancelSaleTaskAccept({ orderCancelReason = '' }) {
      this.cancelSaleTaskAccept({
        orderCancelReason: orderCancelReason,
        success: (res) => {
          if (res.Data && res.Data.isNewPerson != null) {
            Utils.setNewcomerStorage(res.Data.isNewPerson)
          }
          this.$router.replace({ name: 'souhuo' })
        },
        fail: (errMsg) => {
          if (errMsg === '任务已取消') {
            Toast('任务已取消，无需重复操作，将自动跳转首页')
            setTimeout(() => {
              this.$router.replace({ name: 'souhuo' })
            }, 3000)
          } else {
            Toast(errMsg)
          }
        }
      })
    }
  },
  filters: {
    toFixed(value) {
      if (!value) {
        value = 0
      }
      return parseFloat(value).toFixed(2)
    }
  },
  beforeRouteEnter(to, from, next) {
    let fromRoutes = ['stepThree', 'pddStepThree', 'jdStepThree', 'dyStepThree', 'order', 'diffPeiceFeedback', 'pddBaseStepTwo', 'jdBaseStepTwo', 'dyBaseStepTwo', 'checkPeiceFeedback']
    if (fromRoutes.indexOf(from.name) !== -1 || !from.name) {
      next((vm) => {
        vm.fromRouterName = from.name
      })
    } else {
      next({ name: 'souhuo' })
    }
  },
  beforeRouteLeave(to, from, next) {
    next()
  }
}
</script>

<style scoped="scoped">
.ordersubmit-container {
  width: 100%;
  min-height: 100vh;
  overflow: scroll;
  background: #f2f2f2;
  font-size: 14px;
}
.flex {
  display: flex;
}
.align-items {
  align-items: center;
}
.space-between {
  justify-content: space-between;
}
.b_black {
  background: #2c2c2c;
  color: #fff;
}
.tr {
  text-align: right;
}
.icon-time-block span {
  display: block;
  padding: 5px 0;
  text-align: right;
  font-size: 14px;
}
.order-time {
  align-items: center;
  padding: 0 4%;
  height: 9vh;
  line-height: 9vh;
  font-size: 18px;
  box-sizing: border-box;
}
.order-time .iconfont {
  font-size: 18px;
}
.order-time .title-tip {
  line-height: 22px;
}
.icon-time {
  padding-right: 10px;
  font-weight: bold;
}
.item-title {
  display: flex;
  align-items: center;
  width: 100%;
  height: 6.3vh;
  line-height: 6.3vh;
  box-sizing: border-box;
  margin-top: 1.5vh;
  padding: 0 1%;
  font-size: 14px;
  border-bottom: 1px solid #eee;
}
.order-title-left {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #fff;
  padding: 3%;
  border-radius: 5px;
  height: 16px;
}
.order-title-left.promoteZIndex {
  z-index: 99998;
}
.title-img {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: #ec0536;
  border-radius: 3px;
  padding: 2px 3px;
  margin-right: 5px;
  height: 11px;
}
.title-img img {
  display: block;
  width: 21px;
  height: 11px;
}
.title-img img {
  width: 22.64px;
}
.title-img.pdd {
  background: #cf0107;
}
.title-img.jd {
  background: linear-gradient(to bottom, #fae6b4, #f6d9a1);
}
.title-img.pdd img {
  width: 28.78px;
}
.title-img.jd img {
  width: 22.64px;
}
.item-list,
.order-id {
  padding: 2% 1%;
}
.err-b {
  position: relative;
  z-index: 99;
  width: 100%;
  line-height: 1.5em;
  padding: 0.2em;
  margin-top: 3%;
  box-sizing: border-box;
}
.item-image {
  position: relative;
  width: 98px;
  height: 98px;
  margin-right: 10px;
  flex-shrink: 0;
}
.item-image img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.item-txt {
  position: relative;
  height: 7em;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.item-txt-top-1 {
  height: 40px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.item-txt-top-1 span {
  margin-right: 3%;
}
.item-txt-btm {
  display: flex;
  flex-direction: column;
  min-width: 90%;
}
.item-txt-btm .price {
  color: #ff0000;
  font-weight: 600;
}
.item-txt-btm .goods-tag {
  margin-top: 5px;
}
.item-txt-btm .tag {
  display: inline-block;
  color: #ff0000;
  background: #fef0f0;
  border-radius: 3px;
  padding: 0 5px;
  margin-right: 5px;
  font-size: 13px;
  cursor: pointer;
}
.item-describe {
  background: #f05c61;
  color: #ffffff;
  font-size: 13px;
  padding: 3% 4%;
  position: relative;
}
.icon-sanjiaoxing-copy {
  top: -1.1em;
  color: #f05c61;
}
.item-describe .iconfont,
.err-b .iconfont {
  position: absolute;
  font-size: 1.5em;
  left: 1.1em;
}
.err-b .iconfont {
  color: #2c2c2c;
  bottom: -15px;
}
.d-list-text {
  align-items: center;
  border-bottom: 1px solid #eee;
  padding: 3% 4%;
  min-height: 2.5em;
}
.title-width {
  width: 105px;
}
.d-list-text .iconfont span {
  margin-left: 10px;
}
.d-list-text .middle {
  align-items: center;
  flex-shrink: 0;
}
.d-list-text .tip {
  color: #898989;
  margin-left: 4px;
}
.d-list-left span {
  display: block;
  line-height: 1.3em;
}
.list-text-form {
  flex: 1;
  align-items: center;
}
.list-text-form button {
  flex-shrink: 0;
}
.list-text-form input {
  text-align: right;
  width: 100%;
  height: 2.5em !important;
  line-height: 2.5em !important;
}
.describe-list {
  margin-top: 3%;
}
.question {
  margin-left: 10px;
  background: #2c2c2c;
  color: #fff;
  width: 1em;
  height: 1em;
  font-size: 13px;
  text-align: center;
  line-height: 1em;
  border-radius: 100%;
  align-self: center;
}
.order-id {
  position: relative;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding: 4% 2%;
}
.sub-upload {
  margin: -2px 0 5.3em 0;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.or-tag {
  border-radius: 80px;
  font-size: 13px;
  padding: 0;
  margin: 0;
  margin-left: 10px;
  background: #fff;
  border: 1px solid;
  padding: 5px 15px;
}
.order-btn {
  justify-content: flex-end;
  position: fixed;
  align-items: center;
  bottom: 0;
  height: 65px;
  line-height: 65px;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  z-index: 100;
}
.order-btn button {
  font-size: 14px;
  padding: 0px 15px;
  height: 2.5em;
  line-height: 2.5em;
  margin: 0;
}
.order-btn .btn-margin {
  margin: 0 15px;
}
.platform-know {
  position: absolute;
  left: 10px;
  top: 0;
  height: 100%;
  color: #f23030;
}
.platform-know i {
  margin-right: 5px;
}
.mar_t_20 {
  margin-top: 2%;
}
.mar_150 {
  margin-bottom: 5.3em;
}
.priceDiff {
  background: #409eff;
  color: #fff;
  margin-right: 10px;
  padding: 0 10px;
  height: 25px;
  line-height: 25px;
  border-radius: 15px;
  cursor: pointer;
}
.order_from {
  display: block;
  padding-bottom: 5em;
}
.weui-cell {
  padding: 3% 4%;
  min-height: 2.5em;
}
/**
    upload
   */
.upload-input {
  height: 100%;
  width: 100%;
  display: block;
}
.weui-cell {
  padding: 10px 15px;
  position: relative;
  display: flex;
  align-items: center;
  padding: 3 4%;
  min-height: 2.5em;
}
.weui-uploader__bd {
  margin-bottom: -4px;
  margin-right: -9px;
  overflow: hidden;
}
.weui-uploader__input-box {
  float: left;
  position: relative;
  margin-right: 9px;
  margin-bottom: 9px;
  width: 77px;
  height: 77px;
  border: 1px solid #d9d9d9;
}
.weui-uploader__input-box:before {
  width: 2px;
  height: 39.5px;
}
.weui-uploader__input-box:before,
.weui-uploader__input-box:after {
  content: ' ';
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background-color: #d9d9d9;
}
.weui-uploader__input-box:after {
  width: 39.5px;
  height: 2px;
}
.weui-uploader__input-box:before,
.weui-uploader__input-box:after {
  content: ' ';
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background-color: #d9d9d9;
}
.weui-uploader__input {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.weui-uploader__img {
  display: block;
  width: 79px;
  height: 79px;
  overflow: hidden;
}
.weui-uploader__file {
  float: left;
  margin-right: 9px;
  margin-bottom: 9px;
  width: 79px;
  height: 79px;
  background: no-repeat center center;
  background-size: cover;
}
.weui-uploader__file_status {
  position: relative;
  display: block;
}
.weui-uploader__file_status:before {
  content: ' ';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.weui-uploader__file-content {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
}
.upload-img img {
  pointer-events: none;
}
/*
   * walk through
   */
.through-anim {
  animation-fill-mode: backwards;
  animation: opacityAnim 0.2s ease-in;
}
.walk-through .overlay-hole-img {
  position: absolute;
  top: 17.8vh;
  left: 0.8%;
  height: 100px;
  width: 100px;
  border-radius: 6px;
  background: transparent;
  z-index: 99998;
  animation-fill-mode: backwards;
  animation: opacityAnim 0.2s ease-in;
}
.tool-tip .tooltip_err {
  position: absolute;
  top: 23vh;
  left: 4vh;
  display: block;
  width: 326px;
  height: 218px;
  animation-fill-mode: backwards;
  animation: opacityAnim 0.2s ease-in;
}
.tool-tip .tooltip_btn {
  position: absolute;
  width: 121px;
  right: 2vh;
  top: 49vh;
  cursor: pointer;
  animation-fill-mode: backwards;
  animation: opacityAnim 0.2s ease-in;
}
.goods-img-level {
  position: absolute;
  z-index: 99999;
}
.walk-through-hidden {
  z-index: -1 !important;
}
@media screen and (min-height: 812px) {
  .tool-tip .tooltip_btn {
    top: 41vh;
  }
}
.guideGoodsNameClass {
  position: absolute;
  /* background: transparent; */
  z-index: 99999998;
  background-color: transparent;
}
</style>
